var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.739,
    height: 19.872,
    viewBox: "0 0 18.739 19.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Setting",
    "data-name": "Iconly/Light/Setting",
    transform: "translate(-2.404 -1.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setting",
    transform: "translate(3.279 2.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33946",
    d: "M16.753,5.109l-.595-1.032A1.828,1.828,0,0,0,13.664,3.4h0a1.82,1.82,0,0,1-2.493-.647,1.75,1.75,0,0,1-.245-.875h0A1.828,1.828,0,0,0,9.1,0H7.9A1.82,1.82,0,0,0,6.08,1.828h0a1.828,1.828,0,0,1-1.828,1.8,1.75,1.75,0,0,1-.875-.245h0a1.828,1.828,0,0,0-2.493.674L.244,5.109A1.828,1.828,0,0,0,.909,7.6h0a1.828,1.828,0,0,1,.914,1.583,1.828,1.828,0,0,1-.914,1.583h0a1.82,1.82,0,0,0-.665,2.485h0l.6,1.041A1.828,1.828,0,0,0,3.341,15h0a1.811,1.811,0,0,1,2.485.665,1.75,1.75,0,0,1,.245.875h0A1.828,1.828,0,0,0,7.9,18.372H9.1a1.828,1.828,0,0,0,1.828-1.82h0a1.82,1.82,0,0,1,1.828-1.828,1.863,1.863,0,0,1,.875.245h0a1.828,1.828,0,0,0,2.493-.665h0l.63-1.05a1.82,1.82,0,0,0-.665-2.493h0a1.82,1.82,0,0,1-.665-2.493,1.793,1.793,0,0,1,.665-.665h0a1.828,1.828,0,0,0,.665-2.485h0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_737",
    cx: 2.52,
    cy: 2.52,
    r: 2.52,
    transform: "translate(5.983 6.666)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemSettingsIcon);
export default __webpack_public_path__ + "static/media/menu-item-settings-icon.b8abe78850df07d83beb654576292b08.svg";
export { ForwardRef as ReactComponent };